module.exports = __webpack_public_path__ + "img/1-min.8d749030.jpg";